import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { hourValidation, notBlankValidation } from '../../../utils/validations';
import Input from '../../shared/input/Input';

const TaskForm = ({ onSubmit, initTask = {}, readOnly, loading }) => {
  const methods = useForm({ defaultValues: initTask });
  return (
    <FormProvider {...methods}>
      <form id="task-form" noValidate className="modal-form" onSubmit={methods.handleSubmit((data) => onSubmit(data))}>
        <Input
          label="Назва послуги"
          type="input"
          name="name"
          autoFocus="true"
          disabled={readOnly || loading}
          placeholder={'Введіть назву послуги'}
          validation={notBlankValidation}
        />
        <Input
          label="Орієнтовні нормо-години"
          type="number"
          name="hours"
          disabled={readOnly || loading}
          placeholder={'Введіть нормо-години'}
          validation={hourValidation}
        />
      </form>
    </FormProvider>
  );
};

export default TaskForm;
